// errorElement for the public /i/:slug route. A client must NEVER see React
// Router's raw "Unexpected Application Error!" dev screen (it leaks technical
// messages). routes.tsx imports this eagerly, so it stays light: no client.css,
// no form components, only Tailwind on the semantic tokens, which follow the
// same light/dark mode as the client form. It mirrors the form's "couldn't
// load" state. The underlying error is logged for the baker, not shown.

import type { ReactElement } from "react";
import { CircleAlert } from "lucide-react";
import { useRouteError } from "react-router-dom";
import { Button } from "@/core/components/ui/button";

export function InquiryFormErrorScreen(): ReactElement {
  const error = useRouteError();
  // Surface the real cause in the console for debugging; never to the client.
  console.error("Inquiry form route error", error);

  return (
    <main className="min-h-dvh bg-background text-foreground">
      <div className="mx-auto grid w-full max-w-[640px] justify-items-center gap-4 px-5 pt-12 pb-10 text-center">
        <span
          className="grid size-16 place-items-center rounded-full bg-secondary text-primary"
          aria-hidden="true"
        >
          <CircleAlert className="size-7" />
        </span>
        {/* The form's serif; Georgia until the form's font has loaded. */}
        <h1 className="m-0 font-['Cormorant_Garamond',Georgia,serif] text-[30px] leading-[1.1] font-semibold">
          Something went wrong
        </h1>
        <p className="m-0 max-w-[420px] text-[15px] leading-[1.55] text-muted-foreground">
          We couldn&apos;t load this form just now. Please refresh the page — if it keeps happening,
          reach out to the bakery directly and we&apos;ll help you place your order.
        </p>
        <Button
          type="button"
          onClick={() => {
            window.location.reload();
          }}
        >
          Refresh
        </Button>
      </div>
    </main>
  );
}
